export const childAgeString = (age: number) => (age >= 0 ? age.toString() : '0')
